module.exports = __webpack_public_path__ + "static/media/icon_103.ce7a3d7f.svg";